var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',[_vm._v(_vm._s(_vm.$t('widget.usp.heading')))]),_vm._v(" "),(_vm.mainUsps && _vm.mainUsps.length)?_c('ul',{staticClass:"space-y-2"},_vm._l((_vm.mainUsps),function(item){return _c('li',{key:item.name,staticClass:"flex items-center"},[_c(item.alternateUrl ? 'a' : 'NuxtLink',_vm._b({tag:"component",staticClass:"hover:underline flex items-center"},'component',
          item.alternateUrl
            ? {
                href: item.alternateUrl,
              }
            : {
                to: _vm.localePath(
                  item.url
                    ? {
                        name: 'all',
                        params: { pathMatch: item.url },
                      }
                    : {
                        name: 'index',
                      }
                ),
              }
        ,false),[_c('BaseIcon',{staticClass:"w-4 h-4 mr-2 text-gw-green",attrs:{"name":"gw-check"}}),_vm._v(" "),_c('span',{staticClass:"font-bold"},[_vm._v("\n          "+_vm._s(item.title)+"\n        ")])],1)],1)}),0):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }